export { default as InvestmentsPage } from './Investments'